import { render, staticRenderFns } from "./OsPanelCardItemTopbar.vue?vue&type=template&id=53085fb4&scoped=true&"
import script from "./OsPanelCardItemTopbar.vue?vue&type=script&lang=js&"
export * from "./OsPanelCardItemTopbar.vue?vue&type=script&lang=js&"
import style0 from "./OsPanelCardItemTopbar.vue?vue&type=style&index=0&id=53085fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53085fb4",
  null
  
)

export default component.exports